export default __webpack_public_path__ + "static/media/vid-holder-cartel-district.e55d6d73.png";